const isComplementaryKillswitchEnabled = () => !!Sephora.configurationSettings?.genAIChatBotComplementaryProducts?.isEnabled;

const isComplementaryEnabled = () => isComplementaryKillswitchEnabled();

export {
    isComplementaryEnabled, isComplementaryKillswitchEnabled
};
